<!--
	We are currently upgrading/experiencing issues/… things might not work as usual.
-->
<template>
	<session-message :from="item">
		<span v-tr="'SiteSlowWarning_SingleLine'" />
	</session-message>
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "../../../Reinforced.Typings";
import SessionMessage from "./SessionMessage.vue";
import { Notification } from "./Shared/Notification";

@Component({
	components: { SessionMessage },
})
export class SiteSlowWarning extends Notification<MiaPlaza.Control.Vue.Notifications.ISiteSlowWarning> {
	get item(): MiaPlaza.Control.Vue.Notifications.ISessionMessage {
		return {
			...this.from,
			// Message is set through the default slot in the template, this parameter is ignored.
			Message: "…",
			Template: "SessionMessage",
			Type: MiaPlaza.Control.Vue.Notifications.SessionMessageType.Warning,
		};
	}
}

export default toNative(SiteSlowWarning);
</script>
